import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-800 text-white py-6">
      <div className="max-w-6xl mx-auto px-4 text-center text-sm">
        <p className="mb-3 text-xs text-gray-400 italic">
          {t('disclaimer')}
        </p>
        <p className="mb-2">{t('footer')}</p>
        <div className="flex justify-center gap-4 text-xs text-gray-400">
          <a href="#mentions" className="hover:text-white transition-colors">
            {t('legalNotice')}
          </a>
          <span>•</span>
          <a href="#cgv" className="hover:text-white transition-colors">
            {t('terms')}
          </a>
          <span>•</span>
          <a href="#confidentialite" className="hover:text-white transition-colors">
            {t('privacy')}
          </a>
          <span>•</span>
          <a href="#apropos" className="hover:text-white transition-colors">
            {t('about')}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;